
<div class="export-sidebar">
  <div class="header d-flex w-100 align-items-center py-2 px-4">
    <a :href="`/dashboard/report_list?type=${selectedExportReport.type}`">
      <v-icon dense color="#3F3F3F" size="24">mdi-arrow-left</v-icon>
    </a>
    <div>
      <template v-if="isTruncated">
        <v-tooltip bottom max-width="280px">
          <template v-slot:activator="{ on, attrs }">
            <h3 ref="reportTitle" class="ma-0 font-bold" v-bind="attrs" v-on="on" style="width: 350px;">
              {{ truncate(selectedExportReport.name || '') }}
            </h3>
          </template>
          <span>{{ selectedExportReport.name }}</span>
        </v-tooltip>
      </template>
      <h3 v-else class="ma-0 font-bold" style="width: 350px; text-wrap: no-wrap;">{{ selectedExportReport.name }}</h3>
      <h6 class="ma-0 mt-2">{{ mappedType }}</h6>
    </div>
  </div>

  <div v-if="reportType === 'Report::Sales'" class="export-select mx-6 mt-4">
    <div role="button" @click="exportSelect = 'template'" class="export-choice"
      :class="{ selected: exportSelect === 'template' }">Report Template</div>
    <div role="button" @click="exportSelect = 'collection'" class="export-choice"
      :class="{ selected: exportSelect === 'collection' }">Collection</div>
  </div>

  <template v-if="exportSelect === 'template'">
    <div class="report-container">
      <div class="report-content">
        <div class="px-6 mt-3 d-flex justify-content-between align-items-center">
          <h5 class="font-bold"
            style="max-width: 70%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">Columns</h5>
          <a v-if="selectedExportReport && isAdminsRole"
            :href="`/dashboard/template_builder/${selectedExportReport.id}`" class="d-flex align-items-center"
            style="color: #2f80ed;">
            <v-icon color="#2f80ed" dense class="mr-1">mdi-pencil-outline</v-icon>
            Edit Template
          </a>
        </div>
        <div v-if="isLoading" class="d-flex justify-content-center align-items-center py-4 h-100">
          <v-progress-circular color="primary" indeterminate></v-progress-circular>
        </div>
        <template v-else>
          <div v-if="sortedReportFields.length" class="report-fields">
            <div v-for="(field, index) in sortedReportFields" :key="index" class="column-item">
              <div v-if="field.category_key === 'Questionnaire::Template'" class="d-flex flex-column ml-2">
                <b class="mb-1">#{{ field.fieldable_id }} {{ field.header_name || field.original_header_name }}</b>
                <div v-for="(item, index) in field.csv_header_name" :key="index" class="d-flex flex-column ml-2"
                  style="gap: 4px;">
                  <b style="font-size: 12px;">{{ item }}</b>
                  <i style="color: #848484; font-size: 12px;">{{ item }}</i>
                </div>
              </div>
              <div v-else class="d-flex flex-column ml-2">
                <b>{{ getFieldLabel(field) }}</b>
                <i style="color: #848484; font-size: 12px;">{{ field.original_header_name }}</i>
              </div>
            </div>
          </div>
          <i v-else class="d-flex justify-content-center align-items-center h-100 py-2">No Data</i>
        </template>
      </div>
    </div>
  </template>

  <div v-if="exportSelect === 'collection'" class="py-4 px-6 export-collection">
    <i class="ma-0 export-information mb-4">This will generate a .csv that groups the payments data and calculates the
      value by total paid payment.</i>
    <div class="text-sm mb-2">Group By</div>
    <CSelectNew class="mb-4 text-xs h-auto" v-model="exportGroupBy" :options="groupByOptions" :itemValue="'value'"
      :itemText="'text'"></CSelectNew>
    <div class="text-sm mb-2">Calculated Value</div>
    <CInput class="mb-4 text-xs h-auto" value="Total Paid Payment" disabled></CInput>
    <h5 class="font-bold">Exported Columns</h5>
    <div v-if="sortedCollectionFields.length" class="report-fields p-0 mt-2">
      <div v-for="(field, index) in sortedCollectionFields" :key="index" class="column-item">
        <div class="d-flex flex-column ml-2">
          <b>{{ field.header_name || field.original_header_name }}</b>
          <i style="color: #848484; font-size: 12px;">{{ field.header_name || field.original_header_name }}</i>
        </div>
      </div>
    </div>
  </div>
</div>
